import { baseApi } from '@/store/baseApi';
import { APIResponse } from '@web/types';

import type {
  LoginPayload,
  LoginResponse,
  LogoutResponse,
  ResendVerificationPayload,
  ResendVerificationResponse,
  SignupPayload,
  SignupResponse,
  VerifyPayload,
  VerifyResponse,
  ForgotPasswordPayload,
  ForgotPasswordResponse,
  RefreshTokenPayload,
  RefreshTokenResponse,
  ResetPasswordPayload,
  ResetPasswordResponse,
  ChangePasswordPayload,
  ChangePasswordResponse,
  WorkspaceSwitchPayload,
  WorkspaceSwitchResponse,
} from '@/features/auth/types';

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<APIResponse<LoginResponse>, LoginPayload>({
      query: (body) => ({
        url: 'auth/login',
        method: 'POST',
        body,
      }),
    }),
    register: builder.mutation<APIResponse<SignupResponse>, SignupPayload>({
      query: (body) => ({
        url: 'auth/register',
        method: 'POST',
        body,
      }),
    }),
    verify: builder.mutation<APIResponse<VerifyResponse>, VerifyPayload>({
      query: (body) => ({
        url: 'auth/verify',
        method: 'POST',
        body,
      }),
    }),
    resendVerification: builder.mutation<
      APIResponse<ResendVerificationResponse>,
      ResendVerificationPayload
    >({
      query: (body) => ({
        url: 'auth/resend-verification',
        method: 'POST',
        body,
      }),
    }),
    logout: builder.mutation<APIResponse<LogoutResponse>, void>({
      query: () => ({
        url: 'auth/logout',
        method: 'POST',
      }),
    }),
    refresh: builder.mutation<
      APIResponse<RefreshTokenResponse>,
      RefreshTokenPayload
    >({
      query: (body) => ({
        url: 'auth/refresh',
        method: 'POST',
        body,
      }),
    }),
    switchWorkspace: builder.mutation<
      APIResponse<WorkspaceSwitchResponse>,
      WorkspaceSwitchPayload
    >({
      query: (body) => ({
        url: 'auth/switch-workspace',
        method: 'POST',
        body,
      }),
    }),
    forgotPassword: builder.mutation<
      APIResponse<ForgotPasswordResponse>,
      ForgotPasswordPayload
    >({
      query: (body) => ({
        url: 'auth/forgot-password',
        method: 'POST',
        body,
      }),
    }),
    resetPassword: builder.mutation<
      APIResponse<ResetPasswordResponse>,
      ResetPasswordPayload
    >({
      query: (body) => ({
        url: 'auth/reset-password',
        method: 'POST',
        body,
      }),
    }),
    changePassword: builder.mutation<
      APIResponse<ChangePasswordResponse>,
      ChangePasswordPayload
    >({
      query: (body) => ({
        url: 'auth/change-password',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useVerifyMutation,
  useResendVerificationMutation,
  useLogoutMutation,
  useRefreshMutation,
  useSwitchWorkspaceMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useChangePasswordMutation,
} = authApi;
